// @ts-check

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BlockStack, Layout, Page } from "@shopify/polaris";

import { usePostHog } from "posthog-js/react";

import { LockableCard } from "components/cards/LockableCard/LockableCard";
import { ConnectableAccountOnboarding } from "components/ConnectableAccountOnboarding/ConnectableAccountOnboarding";

import { useGlobalContext } from "context/GlobalContext";

export default function AdCampaignsSetupPage() {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const { locked } = useGlobalContext();

  useEffect(() => {
    posthog.capture("$pageview");
  }, []);

  return (
    <Page
      title="Ad campaigns setup"
      backAction={{
        content: "Back to Ad campaigns",
        onAction: () => {
          navigate("/ad-campaigns");
        },
      }}
    >
      <Layout>
        <Layout.Section>
          <BlockStack gap="200">
            <LockableCard locked={locked}>
              <ConnectableAccountOnboarding />
            </LockableCard>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </Page>
  );
};
